import {
  FETCH_SIDEBAR_NAV_FULFILLED,
  FETCH_ALERT_CONTENT_FULFILLED
} from '../actions/types'

export default function reducer (state = {
  alert: null,
  error: null,
  loading: false,
  sidebar: []
}, action) {
  switch (action.type) {
    case FETCH_SIDEBAR_NAV_FULFILLED: {
      return { ...state, sidebar: action.payload }
    }
    case FETCH_ALERT_CONTENT_FULFILLED: {
      return { ...state, alert: action.payload }
    }
    default:
      return state
  }
}
